import { ValidateSapCustomer } from '../../models'
import { ValidateSapCustomerDto } from '../dto'

export const sapValidationDtoToModelTransformer = (sapValidation: ValidateSapCustomerDto | undefined): ValidateSapCustomer => {
  return {
    isValid: sapValidation?.valid ?? false,
    isUnique: sapValidation?.unique ?? false,
  }
}
